import { HEADER_TITLE } from "../constants/ActionTypes";

export function changeHeaderTitle(payload) {
  return { type: HEADER_TITLE, payload }
}
